<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Withdrwal" :breadcrumb="breadcrumb"/>
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Withdrawal</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Currency</label>
                  <div class="col-sm-9">
                    <select class="form-control" v-model="selectedValet" name="valet">
                      <option :key="valetIndex" :value="valet" v-for="(valet, valetIndex) in valetData">
                        {{ valet.currency.code }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Method</label>
                  <div class="col-sm-9">
                    <select class="form-control" v-model="selectedIndex">
                      <option :key="index" :value="index" v-for="(row, index) in data">
                        {{ row.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <Form @submit="submit">
                <div class="form-group row" v-for="({ type, Name, required }, index) in fields" :key="index">
                  <label class="col-sm-3 col-form-label" :for="Name">{{ Name }}</label>
                  <div class="col-sm-9">
                    <Field
                        class="form-control"
                        :type="type"
                        :id="Name"
                        :name="Name"
                        :rules="required? 'required': ''"
                    />
                    <ErrorMessage :name="Name"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-10">
                    <Button class="btn btn-primary" :loading="loader" >Add</Button>
                    <Button class="btn btn-dark ml-1" type="button" @click="$router.push({name:'deposit-money'})">Back</Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {

    return {
      loader: false,
      fields: [],
      data: [],
      selectedIndex: 0,
      selectedCurrency: null,
      selectedValet: null,
      valetData: [],
      breadcrumb: [
        {name: 'App'},
        {name: 'Withdrawal'},
        {name: 'Add Method'},
      ],
    }
  },
  mounted() {
    setTimeout(() => {
      this.getValetData()
    }, 1000)

    // this.getFields()
    // this.emitter.on("change-currency", (data) => {
    //   this.selectedCurrency = data
    //   this.fields = []
    //   this.data = []
    //   this.getFields()
    // });


  },
  methods: {
    getValetData() {
      this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.valetData = responseData
            this.setSelectValetValue()
            this.getFields()
          }
        }

      });
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        if (obj.is_default == 1) {
          this.selectedValet = obj
          this.selectedCurrency = obj
        }
      })

    },
    getFields() {
      if (this.selectedCurrency == null) {
        return
      }
      this.makeRequest('post', 'v1/get-all-withdrawal-methods', {
        currencyId: this.selectedCurrency.currency_id
      }, {}, false).then(callResponse => {
        if(typeof(callResponse) != 'undefined'){
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            let responseData = callResponse.response.data.data
            if (code == 200) {
              this.data = responseData
              var fields = responseData[this.selectedIndex].withdrawal_fields
              this.addValueField(fields)
            }
          }
        }
      });
    },
    addValueField(dataFields) {
      dataFields.forEach((obj, index) => {
        dataFields[index].value = ''
      })
      this.fields = dataFields
    },
    submit(values) {
      let data = {
        // userAccountId: this.selectedCurrency.id,
        paymentMethodId: this.data[this.selectedIndex].id,
        details: values
      }
      this.loader = true
      this.makeRequest('post', 'v1/add-withdrawal-method', data).then(callResponse => {
        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            this.$router.push({name: 'with-drawal'})
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }


      });
    },
  },
  watch: {
    selectedIndex(val) {
      this.fields = this.data[val].withdrawal_fields
    },
    selectedValet(val) {
      this.selectedCurrency = val
      this.getFields()
    },
  }
}
</script>

